import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

/**
 * Un component card stateless collassabile
 */
@Component({
  selector: 'fb-card',
  template: `
    <div class="card">
      <div class="title" (click)="toggle.emit()">{{title}}</div>
      <div class="description" *ngIf="opened">
        <ng-content></ng-content>
        <hr>
        {{utils.url}}
      </div>
    </div>
  `,
  styles: [`
    .card { border: 1px solid black; border-radius: 20px }
    .title { padding: 10px }
    .description { padding: 10px; font-style: italic}
  `]
})
export class CardComponent  {
  /**
   * Il titolo da visualizzare
   */
  @Input() title: string;
  /**
   * se il pannello Ã¨ aperto o meno
   */
  @Input() opened: boolean;
  /**
   * L'evento emesso al click della titlebar
   */
  @Output() toggle: EventEmitter<any> = new EventEmitter();

  constructor(public utils: UtilsService) {}
}
